import script from "./VisionMissionComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./VisionMissionComponent.vue?vue&type=script&setup=true&lang=js"

import "./VisionMissionComponent.vue?vue&type=style&index=0&id=61e7c45c&scoped=true&lang=css"

import exportComponent from "D:\\2026\\frontend-melindacvc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61e7c45c"]])

export default __exports__